import { render, staticRenderFns } from "./brightplans-banner.vue?vue&type=template&id=68c7200e&"
import script from "./brightplans-banner.vue?vue&type=script&lang=js&"
export * from "./brightplans-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports